export enum DossierItemCategory {
  Documents = 0,
  Presentations = 1,
  Workbooks = 2,
  Images = 3,
  Other = 99,
}
